module.exports = __webpack_public_path__ + "3b6ed3410e5aa5289d2f0fea4ba21da4.png";